import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(12),
      color: theme.palette.text.secondary,
    },
  }),
  { name: 'Counters' }
);
